module.exports = __webpack_public_path__ + "static/media/logo.822ddcb5.png";